const donationChildRoutes = (prop, mode = false) => [
  {
    path: '',
    name: `${prop}.index`,
    meta: {
      authRequired: mode,
      title: 'Donation',
      withHeader: true,
      transition: false
    },
    component: () => import('../views/pages/donation/index.vue')
  },
  {
    path: 'smartask',
    name: `${prop}.smartask`,
    meta: {
      authRequired: mode,
      title: 'Smartask',
      withHeader: true,
      transition: false
    },
    component: () => import('../views/pages/donation/smartask.vue')
  },
  {
    path: 'checkout',
    name: `${prop}.checkout`,
    meta: {
      authRequired: mode,
      title: 'Checkout',
      withHeader: true,
      transition: true
    },
    component: () => import('../views/pages/donation/checkout.vue')
  },
  {
    path: 'donation-confirmation',
    name: `${prop}.confirmation`,
    meta: {
      authRequired: mode,
      title: 'Confirmation',
      withHeader: true,
      transition: true
    },
    component: () => import('../views/pages/donation/confirmation.vue')
  },
  {
    path: 'receipt',
    name: `${prop}.receipt`,
    meta: {
      authRequired: mode,
      title: 'Receipt',
      withHeader: false,
      transition: true
    },
    component: () => import('../views/pages/donation/receipt.vue')
  }
]

export default donationChildRoutes
